import { useEffect, useCallback, useContext } from 'react';
import service from '../services';
import CustomRouterContext from '../components/Router/RouterContext';
import { useRedirectToCashier } from './useDeeplinkRedirect';

const regexpEventId = new RegExp('^change:page:(.*)');
const regexpCallbackId = new RegExp('^change:page:(.*):(.*)');

export const getMetaInfo = (regexp, id) => {
  if (!regexp || !regexp.exec || !id) {
    return null;
  }
  const result = regexp.exec(id);

  return result ? { page: result[1], type: result[2] } : result;
};

export const getPayload = (event) => {
  return event.payload
    ? event.payload.hasOwnProperty('data')
      ? event.payload.data
      : event.payload
    : undefined;
};

export const useABAPageEventHandler = () => {
  const router = useContext(CustomRouterContext);
  const redirectToCashier = useRedirectToCashier();

  return useCallback(
    (payload) => {
      switch (payload) {
        case 'back-click': {
          router.goBack();
          break;
        }
        case 'redirect-cashier': {
          redirectToCashier();
          break;
        }
        default:
          break;
      }
    },
    [router, redirectToCashier]
  );
};

let stringifiedLastPageEvent = null;

export const useABAPage = (
  pageEvent = null,
  isEnabled = true,
  afterEventCallback
) => {
  const eventHandler = useABAPageEventHandler();

  const onMessageHandler = useCallback(
    (event, pageId) => {
      const metaInfo = getMetaInfo(regexpCallbackId, event?.id);
      if (metaInfo && pageId === metaInfo?.page) {
        const payload = getPayload(event);
        eventHandler(payload);
      }
    },
    [eventHandler]
  );

  useEffect(() => {
    if (pageEvent && isEnabled) {
      const metaInfo = getMetaInfo(regexpEventId, pageEvent?.id);
      const unsubscribe = service.onMessage((event) =>
        onMessageHandler(event, metaInfo?.page)
      );

      const stringifiedPageEvent = `${pageEvent?.id}${JSON.stringify(
        pageEvent?.event
      )}`;
      if (stringifiedLastPageEvent !== stringifiedPageEvent) {
        // This event works as a synchronizer ABA router and host router
        service.publish('event', pageEvent?.id, pageEvent?.event);
        stringifiedLastPageEvent = `${pageEvent?.id}${JSON.stringify(
          pageEvent?.event
        )}`;
      }
      /* that's why here we push everything after change-page-callback
       * because f.e. navbar waiting for change-page to reset itself
       * and then we can update it
       */
      if (afterEventCallback) {
        afterEventCallback();
      }

      return () => {
        stringifiedLastPageEvent = null;
        unsubscribe();
      };
    }
  }, [pageEvent, onMessageHandler, isEnabled, afterEventCallback]);
};
